import type { FC, MouseEventHandler, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { Link } from 'react-router-dom'

import './RouterLink.styles.scss'

export type LinkSize = 'regular' | 'regular-plus' | 'large'
export type ColorMode = 'dark-gray' | 'black' | 'gray'

export const RouterLink: FC<{
  children: ReactNode
  to: string
  size?: LinkSize
  className?: string
  colorMode?: ColorMode
  hasUnderline?: boolean
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined
}> = ({
  to,
  children,
  size = 'regular',
  colorMode = '',
  className = '',
  hasUnderline = true,
  onClick,
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel
  const underlineClassName = hasUnderline ? 'underline' : ''

  return (
    <Link
      to={to}
      // todo: add the disabled mode
      className={`router-link ${whiteLabel} ${size} ${underlineClassName} ${className} ${colorMode} `}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

export default RouterLink
